module.exports = VueResource;


//////////////////
// WEBPACK FOOTER
// external "VueResource"
// module id = f/Qh
// module chunks = 18